export default __webpack_public_path__ + "static/media/no_image_available.aeff05a2.svg";